module.exports = __webpack_public_path__ + "static/logo-fab054f3f0ed591a675566f779bf4f3d.svg";